export { default } from 'ember-resolver/container-debug-adapter';